import React from 'react';
import block from 'bem-cn-lite';
import {Text} from '@gravity-ui/uikit';
import {formatNumber} from '@frontend/shared';
import {formatPriceModal} from '@features/search/utils';

import './Price.scss';

const b = block('price');

export interface PriceProps {
    value: number;
    className?: string;
    format?: 'number' | 'modal';
    triggerClassName?: string;
}

export const Price: React.FC<PriceProps> = ({
    value,
    className,
    format = 'number',
    triggerClassName
}) => {
    let formattedValue: string;

    if (format === 'modal') {
        formattedValue = formatPriceModal(value);
    } else {
        const hasFraction = value % 1 !== 0;
        if (hasFraction) {
            formattedValue = formatNumber(value);
        } else {
            formattedValue = value.toLocaleString('ru-RU', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        }
    }

    return (
        <div className={`${b(null, className)}`}>
            <Text variant="body-1" className={triggerClassName}>
                {formattedValue}
            </Text>
        </div>
    );
};
